import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import FavoriteButtonWrapper from './FavoriteButtonWrapper';

export const USE_ICONS = 'Use Icons';
export const USE_TEXT = 'Use Text';
export const USE_TEXT_AND_ICONS = 'Use text and icons';
export const USE_IMAGES_ICONS = 'Use image icons';
export const USE_TEXT_AND_IMAGES_ICONS = 'Use text and image icons';

const {
    schema: generatedSchema,
    uiSchema: generatedUiSchema,
    group: generatedGroup,
    dependencies: generatedDependencies,
} = customSchemas.GenerateAnalyticsSchema(['Add Favorite', 'Remove Favorite']);

const schema: JSONSchema7 = {
    title: 'Favorite Button',
    description: 'This widget would use text or icons to control the add to favorite',
    type: 'object',
    required: ['storageName'],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        ...generatedSchema,
        storageName: {
            type: 'string',
            description: 'Local storage item name',
            title: 'Storage Name',
            default: 'favorites',
        },
        shouldDisplayTextIconOrBoth: {
            type: 'string',
            title: 'Display option',
            enum: [
                USE_ICONS,
                USE_TEXT,
                USE_TEXT_AND_ICONS,
                USE_IMAGES_ICONS,
                USE_TEXT_AND_IMAGES_ICONS,
            ],
            default: USE_TEXT_AND_ICONS,
            description: 'Select icon or text has a means to display favorite button',
        },
        itemToAddOrRemoveFromFavorite: {
            type: 'string',
            title: 'Item to add to favorite',
            default: '',
            description: 'Place item to you want to store to favorite here',
        },
        activeIconName: {
            type: 'string',
            title: 'Active Icon Name',
            default: '',
            description: 'Use font awesome name',
        },
        inactiveIconName: {
            type: 'string',
            title: 'Inactive Icon Name',
            default: '',
            description: 'Use font awesome name',
        },
        activeImageIconName: {
            type: 'string',
            title: 'Active Image Icon Name',
            default: '',
            description: 'Use Image from media',
        },
        inactiveImageIconName: {
            type: 'string',
            title: 'Inactive Image Icon Name',
            default: '',
            description: 'Use Image from media',
        },
        ariaAnnounceItemAdded: {
            type: 'string',
            title: 'Announce item change (Add)',
            description: 'Use this to announce when items are added',
            default: '',
        },
        ariaAnnouncedRemovedItem: {
            type: 'string',
            title: 'Announce item change (Remove)',
            description: 'Use this to announce items are removed',
            default: '',
        },
        addToFavoriteBtnText: {
            type: 'string',
            title: 'Add to favorite button text',
            description: 'Add text for favorite button. Could be used for aria label as well ',
            default: '',
        },
        removeFromFavoriteBtnText: {
            type: 'string',
            title: 'Remove from favorite button text',
            description: 'Add text to remove from favorite. Could be used for aria label as well',
            default: '',
        },
    },
    dependencies: {
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
        ...generatedDependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: [
            'storageName',
            'shouldDisplayTextIconOrBoth',
            'itemToAddOrRemoveFromFavorite',
            'activeIconName',
            'inactiveIconName',
            'activeImageIconName',
            'inactiveImageIconName',
            'ariaAnnounceItemAdded',
            'ariaAnnouncedRemovedItem',
            'addToFavoriteBtnText',
            'removeFromFavoriteBtnText',
        ],
        ...generatedGroup,
    },
];

const FavoriteButton: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        ...generatedUiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        addToFavoriteBtnText: {
            'ui:widget': 'ResourcePicker',
        },
        removeFromFavoriteBtnText: {
            'ui:widget': 'ResourcePicker',
        },
        activeImageIconName: {
            'ui:placeholder': 'https://',
            'ui:widget': 'MediaPicker',
            'ui:options': {
                isImagePicker: true,
            },
        },
        inactiveImageIconName: {
            'ui:placeholder': 'https://',
            'ui:widget': 'MediaPicker',
            'ui:options': {
                isImagePicker: true,
            },
        },
    },
    templateView: FavoriteButtonWrapper,
    id: 'FavoriteButton',
    group: 'button',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default FavoriteButton;
